import { TONE_CLASS, TONE_DOT_CLASS, type Tone } from '@/lib/tone'
import { cn } from '@/lib/utils'

export function StatusPill({ label, tone, dot, className, title }: { label: string; tone: Tone; dot?: boolean; className?: string; title?: string }) {
  return (
    <span
      title={title}
      className={cn(
        'inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase leading-4 tracking-wide',
        TONE_CLASS[tone],
        className
      )}
    >
      {dot && <span aria-hidden className={cn('h-1.5 w-1.5 rounded-full', TONE_DOT_CLASS[tone])} />}
      {label}
    </span>
  )
}
